import { ClickAwayListener, Dialog, IconButton, Stack } from "@mui/material";
import { Group, Key, Value } from "layouts/aplicacoes/BlogComments/styles";
import CloseIcon from "@mui/icons-material/Close";

interface Content {
  id: number;
  formSlug: string;
  response: string;
}

function ModalContent({
  content,
  onClose,
}: {
  content?: Content | null | undefined;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={!!content}
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "30vw",
        },
      }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Stack>
          <IconButton
            aria-label="close"
            size="large"
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
            }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
          {content && (
            <Stack
              sx={{
                padding: "30px",
                gap: "15px",
              }}
            >
              <Stack>
                {Object.entries(JSON.parse(content.response)).map(
                  ([key, value]: [string, any], index) => (
                    <Group key={index}>
                      <Key>{key}</Key>
                      <Value>{value}</Value>
                    </Group>
                  )
                )}
              </Stack>
            </Stack>
          )}
        </Stack>
      </ClickAwayListener>
    </Dialog>
  );
}

export default ModalContent;
